import { render, staticRenderFns } from "./OverviewModuleTitle.vue?vue&type=template&id=fefce5a4&scoped=true"
import script from "./OverviewModuleTitle.vue?vue&type=script&setup=true&lang=js"
export * from "./OverviewModuleTitle.vue?vue&type=script&setup=true&lang=js"
import style0 from "./OverviewModuleTitle.vue?vue&type=style&index=0&id=fefce5a4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fefce5a4",
  null
  
)

export default component.exports